import type {Icon} from '@primer/octicons-react'

export const SubAgentsIcon16: Icon = props => {
  return (
    <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M5.75 7.5C6.16421 7.5 6.5 7.83579 6.5 8.25V9.75C6.5 10.1642 6.16421 10.5 5.75 10.5C5.33579 10.5 5 10.1642 5 9.75V8.25C5 7.83579 5.33579 7.5 5.75 7.5Z"
        fill="currentColor"
      />
      <path
        d="M11 8.25C11 7.83579 10.6642 7.5 10.25 7.5C9.83579 7.5 9.5 7.83579 9.5 8.25V9.75C9.5 10.1642 9.83579 10.5 10.25 10.5C10.6642 10.5 11 10.1642 11 9.75V8.25Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.25 0C5.83579 0 5.5 0.335786 5.5 0.75C5.5 1.16421 5.83579 1.5 6.25 1.5H7.5V3.5H3.75C2.50736 3.5 1.5 4.50736 1.5 5.75V8H0.75C0.335786 8 0 8.33579 0 8.75C0 9.16421 0.335786 9.5 0.75 9.5H1.5V12.25C1.5 13.4926 2.50736 14.5 3.75 14.5H12.25C13.4926 14.5 14.5 13.4926 14.5 12.25V9.5H15.25C15.6642 9.5 16 9.16421 16 8.75C16 8.33579 15.6642 8 15.25 8H14.5V5.75C14.5 4.50736 13.4926 3.5 12.25 3.5H9V0.75C9 0.335786 8.66421 0 8.25 0H6.25ZM3 5.75C3 5.33579 3.33579 5 3.75 5H12.25C12.6642 5 13 5.33579 13 5.75V12.25C13 12.6642 12.6642 13 12.25 13H3.75C3.33579 13 3 12.6642 3 12.25V5.75Z"
        fill="currentColor"
      />
    </svg>
  )
}
